export default [
  {
    name: 'clzcIsWb',
    method: 'post',
    desc: '火车票预订匹配差旅标准（填写页面）',
    path: '/obt/clzcIsWb',
    params: {
      minZj: '',
      seatType: '',
      trainCode: ''
    }
  },
  {
    name: 'trBookMatchClzc',
    method: 'post',
    desc: '火车票预订匹配差旅标准',
    path: '/obt/trBookMatchClzc',
    params: {
      minZj: '',
      seatType: '',
      trainCode: ''
    },
    loading: '0'
  },
  {
    name: 'trSearch',
    method: 'post',
    desc: '火车票预订匹配差旅标准',
    path: '/obt/trSearch',
    params: {
      fromStationCode: '', // 出发城市三字码
      toStationCode: '', // 到达城市三字码
      byTrainDate: '', // 乘车日期yyyy-MM-dd
      allTrains: true, // 是否包含距发车不到2hours的车次 ,
      minRank: 1, // 本次预订最低差标等级 ,
      includePrice: true, // 是否包含票价
      tripType: '', // 差旅类型 1因公 2因私
      // ticketType: '', // 车票类型
      queryKey: null, // 查询key
      budget: null, // 出差申请单预算金额
      needTrainType: '', // 预订车次类型 高铁:'G'
      trainCode: '' // 车次编码
    }
  },
  {
    name: 'validOrder',
    method: 'post',
    desc: '火车票校验订单接口(重复订单、行程时间冲突订单、临近行程)',
    path: '/obt/validOrder',
    params: {
      fromStationCode: '', // 出发城市站点三字码
      toStationCode: '', // 到达城市站点三字码
      fromDate: '', // 出发日期
      fromTime: '', // 出发时刻
      toDateTime: '', // 到达时间 YYYY-MM-DD hh:mm:ss
      trainCode: '', // 车次
      passengerList: [ // 乘车人列表
        {
          idCode: '', // 证件号码
          passengerName: '' // 乘车人名称
        }
      ]
    }
  },
  {
    name: 'trBookOrder',
    method: 'post',
    desc: '火车票预订',
    path: '/obt/trBookOrder',
    params: {
      'ydType': '1',
      'acceptNoSeat': false,
      'acceptNoTotal': false,
      'acceptOtherSeat': false,
      'ccsqdId': '',
      'ccsqdNo': '',
      'ccsqdRemark': '',
      'chooseSeats': '',
      'costCenterCode': '',
      'costCenterId': '',
      'costCenterName': '',
      'fromDate': '',
      'fromStationCode': '',
      'fromStationName': '',
      'fromTime': '',
      'ifSameOrder': '',
      'ifViolate': '',
      'linkEmail': '',
      'linkMobile': '',
      'linkTel': '',
      'linkman': '',
      'ontTicketPrice': null,
      'orderFrom': '',
      'passengerList': [
        {
          'empId': '',
          'fsEmpId': '',
          'idCode': '',
          'idType': '',  // 证件类型 1:二代身份证:一代身份证 C:港澳通行证 G:台湾通行证 B:护照
          'insureAmount': null, // 保险单价
          'passengerName': '',
          'passengerType': '',
          'phoneNumber': '',
          'sex': '',
          'ticketType': ''
        }
      ],
      'password': '',
      'projectCode': '',
      'projectId': '',
      'projectName': '',
      'reasonCode': '',
      'reasonDesc': '',
      'remark': '',
      'remarksCu': '',
      'routeId': '',
      'seatType': '',
      'seatName': '',
      'sellServiceCharge': null,
      'subjectCode': '',
      'supplierCode': '',
      'supplierId': '',
      'supplierName': '',
      'ticketPrice': null,
      'toDate': '',
      'toStationCode': '',
      'toStationName': '',
      'toTime': '',
      'trainAccount': '',
      'trainCode': '',
      'trainNo': '',
      'isByidcard': '',
      'travelStandard': null,
      'tripType': null,
      'violateitem': '',
      'violateitemCode': '',
      'couponId': '',
    }
  },
  {
    name: 'queryStation',
    method: 'post',
    desc: '查询经停站点',
    path: '/obt/queryStation',
    params: {
      fromStationCode: '', // 出发城市站点三字码
      toStationCode: '', // 到达城市站点三字码
      byTrainDate: '', // 乘车日期yyyy-MM-dd
      trainNo: '', // 列车内部编码
      trainCode: '' // 车次号
    }
  },
  {
    name: '12306Login',
    method: 'post',
    desc: '12306账号校验',
    path: '/obt/trCheckAccount',
    params: {
      password: '', // 密码
      userName: '', // 用户名
      isOpenInvoice: '', // 是否查询发票登录验证 1是0否，不传则是否
      cxrList: [], // 出行人
    }
  },
  {
    name: '12306TravelList',
    method: 'get',
    desc: '12306历史登录账号',
    path: '/obt/trAccountGetList',
    params: {}
  },
  {
    name: '12306AccountDel',
    method: 'get',
    desc: '12306历史登录账号',
    path: '/obt/trAccountDel',
    params: {
      accountId: ''
    }
  },
  {
    name: 'getCityDataByName',
    method: 'post',
    desc: '根据 城市名称获取 火车站点',
    path: '/obt/getCityDataByName',
    params: {
      cityName:''
    }
  },
  {
    name: 'checkLocalHytgry',
    method: 'post',
    desc: '本地人员信息校验',
    path: '/obt/train/shopping/checkLocalHytgry',
    params: {
      passengerList: [
        {
          passengerName: '',
          idType: '',
          idCode: '',
          phoneNumber: '',
          email: ''
        }
      ]
    }
  },
  {
    name: 'checkRyxx',
    method: 'post',
    desc: '人员信息校验 包括上游核验',
    path: '/obt/train/shopping/checkRyxx',
    params: {
      passengerList: [
        {
          passengerName: '',
          idType: '',
          idCode: '',
          expiryDate: '',
          nation: '',
          passengerType: '',
          sex: '',
          born: '',
          phoneNumber: '',
          email: ''
        }
      ],
      reCheck: 0
    }
  },
  {
    name: 'getCheckResult',
    method: 'post',
    desc: '获取人员校验结果',
    path: '/obt/train/shopping/getCheckResult',
    params: {
      passengerList: [
        {
          passengerName: '',
          idType: '',
          idCode: '',
          phoneNumber: '',
          email: ''
        }
      ]
    }
  },
  {
    name: 'sendCheckAccountYzm',
    method: 'post',
    desc: '获取人员校验结果',
    path: '/obt/train/shopping/sendCheckAccountYzm',
    params: {
      userName: '',
      password: '',
      yzm: '',
      isOpenInvoice: '',
    }
  },
  {
    name: 'registerAccount',
    method: 'post',
    desc: '12306注册账号',
    path: '/obt/registerAccount',
    params: {
      userName: '',
      password: '',
      name: '',
      idNo: '',
      mobileNo: '',
    }
  },
  {
    name: 'checkRegisterCode',
    method: 'post',
    desc: '12306注册账号 - 核验',
    path: '/obt/checkRegisterCode',
    params: {
      userName: '',
      password: '',
      name: '',
      idNo: '',
      mobileNo: '',
      isMobileCheck: '',
      mobileSendCode: '',
      message: '',
      mobileReceiveCode: ''
    }
  },
  {
    name: 'findCxrList',
    method: 'post',
    desc: '获取出行人12306账号密码',
    path: '/obt/findCxrList',
    params: {
      cxrList: []
    }
  },
  {
    name: 'getNewest',
    method: 'post',
    desc: '获取当前登录用户最新使用的12306账号',
    path: '/obt/getNewest',
    params: {}
  }, {
    name: 'FindClkList',
    method: 'post',
    desc: '根据12306账号获取常旅客列表',
    path: '/obt/FindClkList',
    params: {
      trainAccount: '', // 12306用户名 ,
      pass: '', // 12306密码
      captchaCode:'',//核验码字段
    }
  }, {
    name: 'saveClk',
    method: 'post',
    desc: '新增/修改12306常旅客',
    path: '/obt/saveClk',
    params: {
      trainAccount: '', // 12306用户名 ,
      pass: '', // 12306密码
      contacts: {
        id: '0', // (integer): 序列号（0表示新增此联系人，>0表示修改此联系人） ,
        name: '', //  (string): 姓名 ,
        sex: '', //  (integer): 性别 0-男 1-女 ,
        birthday: '', //  (string, optional): 出生日期 ,
        country: '', //  (string): 国家 CN中国 ,
        getValidDateEnd: '', //  (string, optional): 证件有效期 yyyyMMdd ,
        identyType: '', //  (string): 证件类型 1-中国居民身份证 2-港澳台居民居住证 C-港澳台居民来往内地通行证 G-台湾居民来往大陆通行证 B-护照 H-外国人永久居留身份证 ,
        identy: '', //  (string): 证件号码 ,
        personType: '', //  (integer): 旅客类型 0-成人 1-儿童 2-学生 ,
        phone: '', //  (string): 手机 11位数手机号 ,
        tel: '', //  (string, optional): 固话 ,
        email: '', //  (string, optional): 邮件 正确格式有校验 ,
        address: '', //  (string, optional): 地址
        desensitization: '', //是否脱敏更新（0表示脱敏，1表示不脱敏）
      }
    }
  }, {
    name: 'deleteClk',
    method: 'post',
    desc: '删除12306常旅客',
    path: '/obt/deleteClk',
    params: {
      passengerName: '', //姓名
      sex: '', //性别
      passengeType: '', //旅客类型 0 成人 1儿童 2学生 3残军
      trainAccount: '', // 12306用户名 ,
      pass: '', // 12306密码
      identyType: '', //  (string): 证件类型 1-中国居民身份证 2-港澳台居民居住证 C-港澳台居民来往内地通行证 G-台湾居民来往大陆通行证 B-护照 H-外国人永久居留身份证 ,
      identy: '', //  (string): 证件号码 ,
    }
  }, {
    name: 'rlSb',
    method: 'post',
    desc: '人脸核验',
    path: '/obt/rlSb',
    params: {
      userName: '', // 12306用户名 ,
      password: '', // 12306密码
      picUrl: '', // (string): 照片路径 多个用逗号拼接，最少一个，最多两个人脸核验照片限制①文件大小：100k以内 ②像素：150*200像素 ③不能带眼镜
      verifyType: '1'
    },
    loading: '0'
  },
  {
    name: 'getInvoiceHeaderList',
    method: 'post',
    desc: '发票抬头查询',
    path: '/obt/getInvoiceHeaderList',
    params: {
      username: '', // 12306用户名 ,
      password: ''
    },
  },
  {
    name: 'delInvoiceHeader',
    method: 'post',
    desc: '发票抬头删除',
    path: '/obt/delInvoiceHeader',
    params: {
      username: '',
      password: '',
      invoiceHeader: '',
      creditCode: ''
    }
  },
  {
    name: 'addInvoiceHeader',
    method: 'post',
    desc: '发票抬头新增',
    path: '/obt/addInvoiceHeader',
    params: {
      username: '',
      password: '',
      invoiceHeader: '',
      creditCode: '',
      invoiceHeaderType: 2,
      defaultFlag: false
    }
  },
  {
    name: 'alterInvoiceHeader',
    method: 'post',
    desc: '发票抬头修改',
    path: '/obt/alterInvoiceHeader',
    params: {
      username: '',
      password: '',
      newInvoiceHeader: '',
      invoiceHeader: '',
      creditCode: '',
      invoiceHeaderType: 2,
      defaultFlag: false
    }
  },
  {
    name: 'unissuedInvoicesList',
    method: 'post',
    desc: 'obt待开发票查询',
    path: '/obt/unissuedInvoicesList',
    params: {
      username: '',
      password: '',
      year:'',
      month:''
    }
  },
  {
    name: 'invoiceHistoryList',
    method: 'post',
    desc: 'obt待开发票查询',
    path: '/obt/invoiceHistoryList',
    params: {
      username: '',
      password: '',
      year:'',
      month:''
    }
  },
  {
    name: 'operateEmail',
    method: 'post',
    desc: 'obt发票邮箱设置',
    path: '/obt/operateEmail',
    params: {
      username: '',
      password: '',
      email:''
    }
  },
  {
    name: 'invoiceSendEmail',
    method: 'post',
    desc: 'obt发票邮箱发送',
    path: '/obt/invoiceSendEmail',
    params: {
      username: '',
      password: '',
      email:'',
      ticketNumber: "",
      year: "",
      month: ""
    }
  },
  {
    name: 'invoicePreview',
    method: 'post',
    desc: 'obt发票预览图',
    path: '/obt/invoicePreview',
    params: {
      username: '',
      password: '',
      ticketNumber: "",
      year: "",
      month: ""
    }
  },
  {
    name: 'invoiceApply',
    method: 'post',
    desc: 'obt开发票',
    path: '/obt/invoiceApply',
    params: {
      username: '',
      password: '',
      ticketNumber: "",
      gmtDeparture: "",
      invoiceHeader: "",
      year: "",
      month: "",
      passengerInfo: {
        seatNo: "",
        coachNo: ""
      }
    }
  },
  {
    name: 'invoiceChangeHeader',
    method: 'post',
    desc: 'obt换开发票',
    path: '/obt/invoiceChangeHeader',
    params: {
      username: '',
      password: '',
      ticketNumber: "",
      invoiceHeader: "",
      year: "",
      month: ""
    }
  }

]
